// Copyright (c) 2016 Deere & Company

import NewTransfer, {getDefaultState} from '../state/new-transfer';
import actions from '../../actions-list';

const updateNewTransfer = (state, action) =>
    NewTransfer.update(state, {
        $set: action.data
    });

const updateNewDealer = (state, action) =>
    NewTransfer.update(state, {
        newDealer: {
            $set: action.dealer
        }
    });

const updateReasonForChange = (state, action) =>
    NewTransfer.update(state, {
        reasonForChange: {
            $set: action.reason
        }
    });

const resetNewTransfer = state =>
    NewTransfer.update(state, {
        $set: getDefaultState()
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_NEW_TRANSFER]: resetNewTransfer,
        [actions.UPDATE_NEW_TRANSFER_NEW_DEALER]: updateNewDealer,
        [actions.UPDATE_NEW_TRANSFER_SUCCESS]: updateNewTransfer,
        [actions.UPDATE_REASON_FOR_CHANGE]: updateReasonForChange
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/new-transfer/reducers/new-transfer.js